import React from 'react';

import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';

import { BUNDLE_CATEGORY_OPTIONS, BundleCategory, UNCATEGORISED } from '../constants';

interface Props {
  value: BundleCategory | null;
  onChange: (category: BundleCategory | null) => void;
}

function BundleCategorySelect({ value, onChange }: Props) {
  return (
    <FormControl fullWidth>
      <InputLabel id="bundle-category-label" shrink>
        Category
      </InputLabel>
      <Select
        labelId="bundle-category-label"
        label="Category"
        value={value ?? UNCATEGORISED}
        onChange={(e) => onChange(e.target.value || null)}
        displayEmpty
        notched
      >
        {BUNDLE_CATEGORY_OPTIONS.map(({ value: option, label }) => (
          <MenuItem key={option} value={option}>
            {label}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>Packaged holidays are priced by the package-holiday calendar.</FormHelperText>
    </FormControl>
  );
}

export default BundleCategorySelect;
